/**
 * Erreurs globales communes à plusieurs modules
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const GLOBAL_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.TEMPLATE_ERROR_PARSING]: {
        messageKey: 'word-template-seems-to-contain-errors-please-check-the-file',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.UNCLOSED_TAG]: {
        messageKey: 'the-template-has-an-error-on-a-tag-please-fix-the-template-and-try-again',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.FILE_NOT_FOUND]: {
        messageKey: 'file-not-found',
        severity: 'error',
    },
    [ERROR_CODES.TEMPLATE_NOT_FOUND]: {
        messageKey: 'file-not-found',
        severity: 'error',
    },
    [ERROR_CODES.ALREADY_EXISTS]: {
        messageKey: 'this-file-already-exists',
        severity: 'error',
    },
    [ERROR_CODES.FORBIDDEN_403]: {
        messageKey: 'you-do-not-have-the-required-rights',
        severity: 'error',
        callbackable: true,
        callbackDescription: 'Callback personnalisé pour gérer les redirects ou actions supplémentaires',
    },
    [ERROR_CODES.TEMPLATE_FILE_MISSING_ON_DISK]: {
        messageKey: 'export-template-file-missing-on-disk',
        severity: 'error',
        closeDelay: 10000,
    },
};
